export default "__VITE_ASSET__DieiQey7__"